import onGetCarePlanMedicalNotes from './onGetCarePlanMedicalNotes';
import onCreateCarePlanMedicalNote from './onCreateCarePlanMedicalNote';
import onUpdateCarePlanMedicalNote from './onUpdateCarePlanMedicalNote';
import onRemoveCarePlanMedicalNote from './onRemoveCarePlanMedicalNote';

export default {
  onGetCarePlanMedicalNotes,
  onCreateCarePlanMedicalNote,
  onUpdateCarePlanMedicalNote,
  onRemoveCarePlanMedicalNote,
};
